import { AnyAction } from "redux";

import { Case, Specimen } from "pwapi";

import {
  CREATE_LIS_SPECIMEN_SUCCESS,
  FETCH_LIS_CASE_REQUEST,
  FETCH_LIS_CASE_SUCCESS,
  UPDATE_LIS_SPECIMEN_SUCCESS,
} from "../constants";

export interface SpecimensState {
  [key: number]: SpecimenState;
}

interface SpecimenState extends Omit<Specimen, "name"> {
  name?: string;
}

const reduceCase = (payload: Case) => {
  const { specimens } = payload;

  return specimens
    ? specimens.reduce(
        (acc: SpecimensState, specimen) => ({
          ...acc,
          [specimen.id || 0]: specimen as SpecimenState,
        }),
        {}
      )
    : {};
};

export const AdminSpecimensReducer = (
  state: SpecimensState = {},
  action: AnyAction
): SpecimensState => {
  switch (action.type) {
    case FETCH_LIS_CASE_REQUEST:
      return {};
    case FETCH_LIS_CASE_SUCCESS:
      return reduceCase(action.payload.response);
    case UPDATE_LIS_SPECIMEN_SUCCESS:
    case CREATE_LIS_SPECIMEN_SUCCESS:
      return {
        ...state,
        [action.payload.response.id]: action.payload.response,
      };
    default:
      return state;
  }
};
